import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const emailTemplateRoutes: RouteRecordRaw[] = [
  {
    path: '/email-templates',
    name: 'email-templates',
    component: () => import('@/modules/email-templates/views/EmailTemplateListView.vue'),
    meta: {
      title: 'Emailove sablony',
      permission: PERMISSIONS.SETTINGS.VIEW,
      projectScoped: true,
    },
  },
]
